/**
 * ============================================================================
 * QUALITY — dashboard structure (spec multi-dashboard R4).
 * ============================================================================
 *
 * The Quality program's WBR, being onboarded (it replaced the retired "kfe"
 * placeholder id — spec dashboard-rename-kfe-quality, sim D532199531). It is
 * OPEN server-side (DashboardPermission.NONE), so every caller can select it
 * and see the coming-soon placeholder.
 *
 * Quality has no hand-authored view yet: its Detailed Summary derives from
 * the definitions catalog ('catalog' — one section per metricGroup,
 * sortOrder), so it renders the day the Quality definitions publish with
 * zero FE change. When Quality's owners want bespoke tables, this file
 * points at a config/views/quality*.json instead — nothing else moves.
 */

import { DashboardStructure } from 'src/config/dashboards/types';

export const quality: DashboardStructure = {
  dashboardId: 'quality',
  displayName: 'Quality',
  // Placeholder while Quality is onboarded: page bodies render "Coming soon"
  // (the switcher/nav stay live). REMOVE this flag when the Quality
  // definitions publish — the catalog-driven view below takes over with no
  // other change.
  comingSoon: true,
  pages: [
    { route: '/', title: 'Executive Summary', kind: 'home' },
    {
      route: '/detailed-view',
      title: 'Detailed View',
      kind: 'view',
      view: 'catalog',
      // Same rule as KFE: the Detailed Summary is the authoring surface
      // (spec metric-callouts R1.7).
      calloutAuthoring: true,
    },
    {
      route: '/action-items',
      title: 'Action Items',
      kind: 'actionItems',
      // Gated on the ACTION_ITEMS feature lock (fail-closed tab + page).
      featureId: 'action_items',
    },
  ],
};
